import { MapContainer } from "react-migration/domains/sites/card/Map";
import { OwnershipInformation } from "./components/OwnershipInformation";

export const Ownership = ({
  geometry,
}: {
  geometry?: GeoJSON.MultiPolygon | GeoJSON.Polygon | GeoJSON.Point;
}) => {
  return (
    <div className="atlas-flex atlas-h-full atlas-p-4" data-testid="ownership-wrapper">
      <div className="atlas-w-1/2 atlas-pr-4" data-testid="ownership-map-container">
        <MapContainer />
      </div>
      <div className="atlas-w-1/2 atlas-bg-neutral-200 atlas-border atlas-border-neutral-200 atlas-overflow-auto atlas-p-3">
        <OwnershipInformation geometry={geometry} />
      </div>
    </div>
  );
};
